import { render, staticRenderFns } from "./SolicitationDetail.vue?vue&type=template&id=349e6faf&scoped=true&"
import script from "./SolicitationDetail.vue?vue&type=script&lang=js&"
export * from "./SolicitationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349e6faf",
  null
  
)

export default component.exports